// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2p6tr","savePackageButton":"ClientWallet_savePackageButton__1DJsy"};